module.exports = __webpack_public_path__ + "static/dh-e8c7e494627d7a119f81fe749f4d7205.png";